import React from "react";
import PropTypes from "proptypes";

const ScubaModal = ({ closeModal }) => (
  <div>
    <div className="row">
      <button className="square-icon right" onClick={closeModal}>
        X
      </button>
    </div>
    <h3>Fast Manta Booking Form Instructions</h3>
    <p>
        <h4>When completing the Fast Manta Form, follow these tips to ensure that your form is completed correctly:</h4>
        <ul>
            <li><b>Date</b>: The start date of your GIVE Scuba trip</li>
            <li><b>Activity</b>: PADI OW Course (Open water), or PADI AOW Course (Advanced Open Water) if you're already Open Water certified. If you're PADI AOW Certified, then contact GIVE.</li>
            <li><b>Name of Hotel</b>: Spirit Mountain</li>
            <li><b>Food Allergies & Intolerances</b>: It will not be possible to change your preferences once the trip begins.</li>
            <li><b>Do you hold valid insurance that covers diving?</b>: Unless you purchased travelers insurance coverage that includes scuba diving, select "No"</li>
            <li><b>Additional Information</b>: GIVE Program</li>
        </ul>
    </p>
  </div>
);

ScubaModal.propTypes = {
  closeModal: PropTypes.func.isRequired
};

export default ScubaModal;
